import React from 'react'
import styled from 'styled-components'
import { colors, media } from '../styles/vars'
import arrowLeft from '../static/images/icons/arrow_left.png'
import { Link } from 'react-router-dom'

const Container = styled.div`
background-color:rgba(255, 255, 255, .8);
margin:20px 0;
${
    media.desktop`
    width:350px;
    &:not(:last-child){
        margin-left:30px;
    }
    `
    }
`
const ImageContainer = styled.div`
position:relative;
background-repeat:no-repeat;
background-size:cover;
background-image:url(${props => props.src});
padding-bottom:65%;

${
    media.desktop`
    padding-bottom:95%;
    `
    }
`
const Title = styled.h3`
position:absolute;
bottom:0;
right:0;
background-color:${colors.black};
color:${colors.yellow};
font-size:2.5rem;
font-weight:700;
padding:7px 7px 3px;
span{
    color:${colors.red};
}
`
const InfoContainer = styled.div`
padding:10px 15px 10px 5px;
`
const Paragraph = styled.p`
font-size:1.8rem;
text-align:right;
margin-bottom:10px;
${
    media.desktop`
    font-size:2.2rem;
    `
}
`
const ArticleLink = styled(Link) `
font-size:2.5rem;
display:block;
text-align:left;
font-weight:700;
&, &:hover, &:visited{
    color:${colors.black};
    text-decoration:none;
}

> *{
    display:inline-block;
    vertical-align:middle;
    cursor:pointer;
}

label {
    margin-left:8px;
}
img{
    width:7px;
}
`
const ArticleListItem = (props) => {
    return (
        <Container>
            <ImageContainer src={props.imageSrc}>
                <Title><span>{props.titlePrefix}</span>{props.title}</Title>
            </ImageContainer>
            <InfoContainer>
                <Paragraph>{props.description}</Paragraph>
                <ArticleLink to={`/article/${props.articleId}`}>
                    <label>לכתבה המלאה</label>
                    <img src={arrowLeft} alt="" />
                </ArticleLink>
            </InfoContainer>
        </Container>
    )
}

export default ArticleListItem;


// WEBPACK FOOTER //
// ./src/components/ArticleListItem.jsx